import { IApplicationState } from '../../types/redux';

export const selectQueryString = (state: IApplicationState) => {
  return state.offersData.queryString;
};
